import React, { useState, useEffect } from "react";
import "./style.scss";
//nav bar
import Navbar from "../../../components/navbar/navbar";
import PageHeader from "../../../components/pageComponents/header";
import ThreeColText from "../../../components/pageComponents/threeColText";
// utile
import { debounce } from "../../../utils/debounce";
import { useTranslation } from "react-i18next";

const EnnemiPage = () => {
  const { t } = useTranslation();
  const [isMobile, setMobile] = useState(
    window.innerWidth <= 600 || window.innerHeight <= 650
  );

  const debouncedHandleResize = debounce(function handleResize() {
    setMobile(window.innerWidth <= 600 || window.innerHeight <= 650);
  }, 300);

  useEffect(() => {
    window.addEventListener("resize", debouncedHandleResize);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  });

  return (
    <div className="App">
      {!isMobile && <Navbar />}
      <div className={isMobile ? "page__mobile" : "page"}>
        <div className="App-header">
          <PageHeader
            title1={t("ami_ennemi_title1")}
            title2={t("ami_ennemi_title2")}
            subtitle={t("ami_ennemi_subtitle")}
            color="#66ccff"
            bgImg={require("../../../images/pages/MytheRite.jpg")}
            isMobile={isMobile}
          >
            <div className="page__content">{t("ami_ennemi_text_intro_1")}</div>
            <div className="page__content">{t("ami_ennemi_text_intro_2")}</div>
            <div className="page__content">{t("ami_ennemi_text_intro_3")}</div>
            <div className="page__content">{t("ami_ennemi_text_intro_4")}</div>
          </PageHeader>
        </div>
        <ThreeColText
          col1Txt={[t("ami_ennemi_text_core_1a"), t("ami_ennemi_text_core_1b"), t("ami_ennemi_text_core_1c")]}
          col2Txt={[t("ami_ennemi_text_core_2a"),t("ami_ennemi_text_core_2b")]}
          col3Txt={[t("ami_ennemi_text_core_3a"),t("ami_ennemi_text_core_3b"), t("ami_ennemi_text_core_3c")]}
          col1Title={[
            t("mythe_text_title_1a"),
            t("mythe_text_title_1b"),
            t("mythe_text_title_1c"),
          ]}
          col2Title={[
            t("mythe_text_title_2a"),
            t("mythe_text_title_2b"),
            t("mythe_text_title_2c"),
          ]}
          col3Title={[
            t("mythe_text_title_3a"),
            t("mythe_text_title_3b"),
            t("mythe_text_title_3c"),
          ]}
          color="#66ccff"
        />
      </div>
    </div>
  );
};

export default EnnemiPage;
